// Modal.jsx (расширенная версия)
import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './WEm.css';
const SERVICE_ID = 'service_ly9w4h4';
const TEMPLATE ='template_ncyc714';
const PUBLIC_KEY ='eMZRqSNwXFXYyxqnR';

function WEm({ isOpen, onClose }) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
const [isSent, setIsSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);

    try {
     const response = await emailjs.send(
        SERVICE_ID,
        TEMPLATE,
        { user_email: email },
        PUBLIC_KEY
      );
         console.log('3. Ответ от EmailJS:', response);
    setIsSent(true);
    setEmail('');
    setTimeout(() => {
        onClose();
        setIsSent(false);    
      }, 2000);
  } catch (error) {
    setIsSent(false);
  } finally {
    setIsLoading(false);
  }
  };

  if (!isOpen) return null;

  return (
    
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Ваш email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isSent}
          />
         <div className="catalog-footer">
      <button className="catalog-btn" type="submit" disabled={isLoading || isSent}>
            {isSent ? 'Уже можешь проверять почту' : isLoading ? 'Отправка...' : 'Отправить'}
          </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default WEm;